module.exports = __webpack_public_path__ + "static/fifth-step-apartados-5c143205ac0c291f3d555731f12efa19.svg";